export const partnerListWithAccess = (partnerList, access) => {
  const updateList = partnerList.map(partner => ({
    ...partner,
    access: {
      role: access.partners.find(accessDetail => String(accessDetail.partner_id) === String(partner.id))?.role,
    },
  }));

  return updateList;
};
